import { ComponentType } from 'react';
import {
  CounterField,
  DateAndTimeField,
  DateRangeField,
  DestinationField,
  HelpTextField,
  HourField,
  IntegerInputField,
  MekleTextInfoField,
  MoneyInputField,
  MultipleChoiceField,
  NumberInputField,
  ObjectCounterField,
  RadioGroupField,
  SelectField,
  TabbedInfoField,
  TextInputField,
  YesNoField
} from '../fields';
import { HelpTextFieldPestInsect } from '../../pages/claimForms/claimFormsPrivate/travel/pestInsect/HelpTextFieldPestInsect';
import { DateField } from '../fields/DateField/DateField';

export const WidgetMap: { [key: string]: any } = {
  ObjectCounterField,
  CounterField,
  MultipleChoiceField,
  DateRangeField,
  HourField,
  HelpTextField,
  HelpTextFieldPestInsect,
  MoneyInputField,
  TextInputField,
  RadioGroupField,
  YesNoField,
  DateField,
  SelectField,
  IntegerInputField,
  NumberInputField,
  TabbedInfoField,
  MekleTextInfoField,
  DateAndTimeField,
  DestinationField
};

export const registerWidget = (name: string, widget: ComponentType<any>) => {
  WidgetMap[name] = widget;
};
